import { Injectable } from '@angular/core';
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root',
})
export class AlertService {
  constructor() {}

  private confirmButtonColor = '#86BC25';

  async exibirError(
    title: string,
    message: string
  ) {
    try {
      return await Swal.fire({
        icon: 'error',
        title: title,
        html: message,
        confirmButtonColor: this.confirmButtonColor,
      });
    } catch (err) {
      throw new Error(err);
    }
  }

  // tslint:disable-next-line:typedef
  async exibirAlert(
    message: string,
    type: 'ERROR' | 'WARNING' | 'SUCCESS' | 'QUESTION' | 'USEREXPIRED',
    timer = 3000
  ) {
    try {
      if (type === 'ERROR') {
        return await Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: message,
          confirmButtonColor: this.confirmButtonColor,
        });
      } else if (type === 'WARNING') {
        return await Swal.fire({
          icon: 'warning',
          title: 'Atenção',
          text: message,
          confirmButtonColor: this.confirmButtonColor,
        });
      } else if (type === 'USEREXPIRED') {
        return await Swal.fire({
          icon: 'warning',
          title: 'Sessão Expirou',
          text: message,
          confirmButtonColor: this.confirmButtonColor,
        });
      
      } else if (type === 'SUCCESS') {
        return await Swal.fire({
          text: message,
          icon: 'success',
          showConfirmButton: false,
          timer,
          confirmButtonColor: this.confirmButtonColor,
        });
      } else if (type === 'QUESTION') {
        return await Swal.fire({
          text: message,
          icon: 'question',
          showConfirmButton: true,
          confirmButtonText: 'Confirmar',
          confirmButtonColor: this.confirmButtonColor,
          showCancelButton: true,
          cancelButtonText: 'Cancelar',
        });
      }
    } catch (err) {
      throw new Error(err);
    }
  }
}
